import { apiClient } from '@devd-client/api';
import { getToken } from '@devd-client/devd/auth';

export const updatePullDays = (params: {
  orgId: string;
  pullDays: number;
}): Promise<any> =>
  apiClient(`/v2/admin/org/${params.orgId}/pull-days`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({ pullDays: params.pullDays }),
  });

export const updateSubscriptionPlan = (params: {
  orgId: string;
  plan?: string;
  endDate?: string;
}): Promise<any> =>
  apiClient(`/v2/admin/org/${params.orgId}/subscription/plan`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      plan: params.plan,
      endDate: params.endDate,
    }),
  });

export const updateEnabledModules = (params: {
  orgId: string;
  modules: Record<string, boolean>;
}): Promise<any> =>
  apiClient(`/v2/admin/org/${params.orgId}/modules`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params.modules),
  });

export const setIntegrationInactive = (params: {
  orgId: string;
  integrationType: string;
  integration: string;
}): Promise<any> =>
  apiClient(
    `/v2/admin/org/${params.orgId}/integration/${params.integrationType}/${params.integration}/inactive`,
    {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
    }
  );

export const resetAccountState = (params: {
  orgId: string;
  integrationKey: string;
  integrationType: string;
  state: string;
}): Promise<any> =>
  apiClient(`/v2/admin/org/${params.orgId}/account-state/reset`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      integrationKey: params.integrationKey,
      integrationType: params.integrationType,
      state: params.state,
    }),
  });

export const deactivateAllActiveIntegrations = (params: {
  orgId: string;
}): Promise<any> =>
  apiClient(`/v2/admin/org/${params.orgId}/integrations/deactivate-all`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });

export const reactivateIntegrations = (params: {
  orgId: string;
}): Promise<any> =>
  apiClient(`/v2/admin/org/${params.orgId}/integrations/reactivate`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });
